import ClientApplicationDetail from './ClientApplicationDetail.container';

export default ClientApplicationDetail;
